import { Grid } from "@mui/material";
import { table5Rows } from "features/analytics";
import {
  ApiChartTemplate,
  ApiChartType,
  ApiDimension,
  ApiMetric,
  ApiYAxisChartType,
} from "@incendium/api";
import { AnalyticsSpacing } from "consts";
import StandardAnalyticsCard from "features/analytics/components/StandardAnalyticsCard";
import {
  CHART_KEY_AUDIENCE_COMPARISON_DEVICE_BROWSERS_PRIMARY_METRICS,
  CHART_KEY_AUDIENCE_COMPARISON_DEVICE_CONVERSIONS_TREND,
  CHART_KEY_AUDIENCE_COMPARISON_DEVICE_EFFECTIVE_RATE_TREND,
  CHART_KEY_AUDIENCE_COMPARISON_DEVICE_PRIMARY_METRICS,
  CHART_KEY_AUDIENCE_COMPARISON_DEVICE_SESSIONS_CONVERSIONS,
  CHART_KEY_AUDIENCE_COMPARISON_DEVICE_SESSIONS_TREND,
  CHART_KEY_AUDIENCE_COMPARISON_DEVICE_TIME_SPENT_TREND,
  CHART_KEY_AUDIENCE_COMPARISON_DEVICE_TOP_BROWSERS,
  CHART_KEY_AUDIENCE_COMPARISON_DEVICE_TOP_INTERACTIONS,
} from "features/analytics/constants/chartKeys";

function AudienceDeviceAndBrowsersTab() {
  return (
    <Grid container spacing={AnalyticsSpacing}>
      <Grid item xs={8} sx={{ minHeight: table5Rows }}>
        <StandardAnalyticsCard
          chartKey={CHART_KEY_AUDIENCE_COMPARISON_DEVICE_PRIMARY_METRICS}
          chart={{
            name: "Desktop & Mobile Users - Primary Metrics",
            dimension: [ApiDimension.DIMENSION_DEVICE],
            template: ApiChartTemplate.TABLE,
            type: ApiChartType.TABLE,
            attributes: [],
            yAxisKeys: [
              {
                key: "l",
                fields: [
                  ApiMetric.METRIC_SESSIONS_COUNT,
                  ApiMetric.METRIC_PAGEVIEWS_COUNT,
                  ApiMetric.METRIC_AVERAGE_TIME_ON_PAGE,
                  ApiMetric.METRIC_EFFECTIVE_SESSION_RATE,
                  ApiMetric.METRIC_MACRO_CONVERSION_RATE,
                  ApiMetric.METRIC_PAGE_MICRO_CONVERSION_RATE,
                ],
              },
            ],
            displayOptions: {
              noFilters: true,
              filterDropdowns: [ApiDimension.DIMENSION_LEAD_AUDIENCE],
            },
          }}
        />
      </Grid>
      <Grid item xs={4}>
        <StandardAnalyticsCard
          chartKey={CHART_KEY_AUDIENCE_COMPARISON_DEVICE_SESSIONS_CONVERSIONS}
          chart={{
            name: "Desktop & Mobile Users - Sessions & Conversions",
            dimension: [ApiDimension.DIMENSION_DEVICE],
            template: ApiChartTemplate.SNAPSHOT,
            type: ApiChartType.GRAPH,
            attributes: [],
            yAxisKeys: [
              {
                key: "l",
                fields: [ApiMetric.METRIC_SESSIONS_COUNT],
                chart: {
                  [ApiMetric.METRIC_SESSIONS_COUNT]: ApiYAxisChartType.BAR,
                },
              },
              {
                key: "r",
                fields: [ApiMetric.METRIC_MACRO_CONVERSION_RATE],
                chart: {
                  [ApiMetric.METRIC_MACRO_CONVERSION_RATE]:
                    ApiYAxisChartType.DOT,
                },
              },
            ],
            displayOptions: {
              noFilters: true,
              filterDropdowns: [ApiDimension.DIMENSION_LEAD_AUDIENCE],
            },
          }}
        />
      </Grid>

      <Grid item xs={8} container spacing={AnalyticsSpacing}>
        <Grid item xs={6} sx={{ minHeight: 450 }}>
          <StandardAnalyticsCard
            chartKey={CHART_KEY_AUDIENCE_COMPARISON_DEVICE_SESSIONS_TREND}
            chart={{
              name: "Desktop & Mobile Users Sessions Trend",
              dimension: [
                ApiDimension.DIMENSION_SESSION_START_BY_DAY,
                ApiDimension.DIMENSION_DEVICE,
              ],
              template: ApiChartTemplate.TREND,
              type: ApiChartType.GRAPH,
              attributes: [],
              yAxisKeys: [
                {
                  key: "l",
                  fields: [ApiMetric.METRIC_SESSIONS_COUNT],
                },
              ],
              displayOptions: {
                noFilters: true,
                filterDropdowns: [ApiDimension.DIMENSION_LEAD_AUDIENCE],
              },
            }}
          />
        </Grid>
        <Grid item xs={6} sx={{ minHeight: 450 }}>
          <StandardAnalyticsCard
            chartKey={CHART_KEY_AUDIENCE_COMPARISON_DEVICE_EFFECTIVE_RATE_TREND}
            chart={{
              name: "Desktop & Mobile Users Effective Rate Trend",
              dimension: [
                ApiDimension.DIMENSION_SESSION_START_BY_DAY,
                ApiDimension.DIMENSION_DEVICE,
              ],
              template: ApiChartTemplate.TREND,
              type: ApiChartType.GRAPH,
              attributes: [],
              yAxisKeys: [
                {
                  key: "l",
                  fields: [ApiMetric.METRIC_EFFECTIVE_SESSION_RATE],
                },
              ],
              displayOptions: {
                noFilters: true,
                filterDropdowns: [ApiDimension.DIMENSION_LEAD_AUDIENCE],
              },
            }}
          />
        </Grid>
        <Grid item xs={6} sx={{ minHeight: 450 }}>
          <StandardAnalyticsCard
            chartKey={CHART_KEY_AUDIENCE_COMPARISON_DEVICE_TIME_SPENT_TREND}
            chart={{
              name: "Desktop & Mobile Users Time Spent Trend",
              dimension: [
                ApiDimension.DIMENSION_SESSION_START_BY_DAY,
                ApiDimension.DIMENSION_DEVICE,
              ],
              template: ApiChartTemplate.TREND,
              type: ApiChartType.GRAPH,
              attributes: [],
              yAxisKeys: [
                {
                  key: "l",
                  fields: [ApiMetric.METRIC_AVERAGE_SESSION_DURATION],
                  chart: {
                    [ApiMetric.METRIC_AVERAGE_SESSION_DURATION]:
                      ApiYAxisChartType.AREA,
                  },
                },
              ],
              displayOptions: {
                noFilters: true,
                filterDropdowns: [ApiDimension.DIMENSION_LEAD_AUDIENCE],
              },
            }}
          />
        </Grid>
        <Grid item xs={6} sx={{ minHeight: 450 }}>
          <StandardAnalyticsCard
            chartKey={CHART_KEY_AUDIENCE_COMPARISON_DEVICE_CONVERSIONS_TREND}
            chart={{
              name: "Desktop & Mobile Users Conversions Trend",
              dimension: [
                ApiDimension.DIMENSION_SESSION_START_BY_DAY,
                ApiDimension.DIMENSION_DEVICE,
              ],
              template: ApiChartTemplate.TREND,
              type: ApiChartType.GRAPH,
              attributes: [],
              yAxisKeys: [
                {
                  key: "l",
                  fields: [ApiMetric.METRIC_MACRO_CONVERSIONS_COUNT],
                  chart: {
                    [ApiMetric.METRIC_MACRO_CONVERSIONS_COUNT]:
                      ApiYAxisChartType.AREA,
                  },
                },
              ],
              displayOptions: {
                noFilters: true,
                filterDropdowns: [ApiDimension.DIMENSION_LEAD_AUDIENCE],
              },
            }}
          />
        </Grid>
      </Grid>

      <Grid item xs={4}>
        <StandardAnalyticsCard
          chartKey={CHART_KEY_AUDIENCE_COMPARISON_DEVICE_TOP_INTERACTIONS}
          chart={{
            name: "Top Interactions by User Type",
            dimension: [
              ApiDimension.DIMENSION_DEVICE,
              ApiDimension.DIMENSION_MICRO_CONVERSION,
            ],
            template: ApiChartTemplate.TABLE,
            type: ApiChartType.TABLE,
            attributes: [],
            orderBy: `${ApiDimension.DIMENSION_DEVICE}`,
            yAxisKeys: [
              {
                key: "l",
                fields: [ApiMetric.METRIC_PAGE_MICRO_CONVERSIONS_COUNT],
              },
            ],
            displayOptions: {
              noFilters: true,
              filterDropdowns: [ApiDimension.DIMENSION_LEAD_AUDIENCE],
              rowsPerPage: 12,
            },
          }}
        />
      </Grid>

      <Grid item xs={8} sx={{ minHeight: table5Rows }}>
        <StandardAnalyticsCard
          chartKey={
            CHART_KEY_AUDIENCE_COMPARISON_DEVICE_BROWSERS_PRIMARY_METRICS
          }
          chart={{
            name: "Browsers - Primary Metrics",
            dimension: [ApiDimension.DIMENSION_BROWSER],
            template: ApiChartTemplate.TABLE,
            type: ApiChartType.TABLE,
            attributes: [],
            yAxisKeys: [
              {
                key: "l",
                fields: [
                  ApiMetric.METRIC_SESSIONS_COUNT,
                  ApiMetric.METRIC_PAGEVIEWS_COUNT,
                  ApiMetric.METRIC_AVERAGE_TIME_ON_PAGE,
                  ApiMetric.METRIC_EFFECTIVE_SESSION_RATE,
                  ApiMetric.METRIC_MACRO_CONVERSION_RATE,
                  ApiMetric.METRIC_PAGE_MICRO_CONVERSION_RATE,
                ],
              },
            ],
            displayOptions: {
              noFilters: true,
              filterDropdowns: [ApiDimension.DIMENSION_LEAD_AUDIENCE],
              availableDimensions: [
                ApiDimension.DIMENSION_BROWSER,
                ApiDimension.DIMENSION_OS,
              ],
            },
          }}
        />
      </Grid>
      <Grid item xs={4}>
        <StandardAnalyticsCard
          chartKey={CHART_KEY_AUDIENCE_COMPARISON_DEVICE_TOP_BROWSERS}
          chart={{
            name: "Top 10 Browsers",
            dimension: [ApiDimension.DIMENSION_BROWSER],
            template: ApiChartTemplate.SNAPSHOT,
            type: ApiChartType.PIE,
            attributes: [],
            limit: 10,
            yAxisKeys: [
              {
                key: "l",
                fields: [ApiMetric.METRIC_SESSIONS_COUNT],
              },
            ],
            displayOptions: {
              noFilters: true,
              filterDropdowns: [ApiDimension.DIMENSION_LEAD_AUDIENCE],
              showTotals: true,
            },
          }}
        />
      </Grid>
    </Grid>
  );
}

export default AudienceDeviceAndBrowsersTab;
